import {Subscription} from "rxjs";
import {WebCompany} from "src/app/models";
import {CompanyService} from "src/app/services";
import {Component, OnInit, OnDestroy} from "@angular/core";
import { SharedService } from "src/app/services";
import { SummaryHeaderComponent } from "src/app/shared/summary-header/summary-header.component";

@Component({
    selector: "app-contact-us",
    templateUrl: "./contact-us.component.html",
    styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit, OnDestroy
{
    title = "";

    company: WebCompany;
    companySubscription: Subscription;
    contactUsEmail: string;

    webSettingsSubscription: Subscription;
    constructor(
        private companyService: CompanyService,
    ) { }

    ngOnInit(): void
    {
        this.companySubscription = this.companyService.company.subscribe(c =>
        {
            this.company = c;
            this.contactUsEmail = SharedService.IsNullOrEmpty(this.company.DisplayEmail)
                ? this.company.WebEmail
                : this.company.DisplayEmail;
        });
    }

    ngOnDestroy(): void
    {
        this.companySubscription.unsubscribe();
    }
}
